import React from 'react';
import Styled from 'styled-components';
import * as color from '../colors';

const Card = Styled.article`
max-width: 35rem;
border: solid 1px ${color.tertiary};
border-radius: 8px;
color: ${color.primary};
background-color:${color.white};
`;
const CardHeader = Styled.header`
display: flex;
align-items: center;
justify-content: center;
margin-top: -5rem;
`;
const CardIcon = Styled.span`
display: flex;
align-items: center;
justify-content: center;
height: 8rem;
width: 8rem;
border-radius: 15rem;
background-color: ${color.tertiaryAlt};
border: solid 1px ${color.tertiary};
img {height: 100%; width: 100%; object-fit: cover;};
`;
const CardBody = Styled.div`
text-align: center;
padding: 2rem;
color: ${color.primary};
margin: 2rem 0;
`;
const CardHeading = Styled.h4`
font-size: 3rem;
line-height: 1;
`;
const CardParagraph = Styled.p`
margin: auto;
font-size: 1.8rem;
max-width: 30ch;
line-height: 1.7;
color: ${color.primary};
${(props) =>
  props.alternative &&
  `text-transform: uppercase;
font-weight: bold;
color: ${color.primaryAlt};
line-height: 1;
color: var(--color-primary-light);
font-size: 1.3rem;`}`;

const CardFooter = Styled.footer`
padding: 3rem 0;
background-color: ${color.lightAlt};
text-align: center;
border-radius: 8px;
`;

const PricingCard = ({ image, type, paragraph, price, brief }) => {
  return (
    <Card>
      <CardHeader>
        <CardIcon>
          <img src={image} alt="" />
        </CardIcon>
      </CardHeader>
      <CardBody>
        <CardHeading>{type}</CardHeading>
        <CardParagraph>{paragraph}</CardParagraph>
      </CardBody>
      <CardFooter>
        <CardHeading>${price}</CardHeading>
        <CardParagraph alternative>{brief}</CardParagraph>
      </CardFooter>
    </Card>
  );
};

export default PricingCard;
